import { Injectable } from '@angular/core';
import { ApiService } from '../../core/api.service';
import { Observable } from 'rxjs';
import { NewsletterSubscription } from './newsletter.model';

@Injectable({ providedIn: 'root' })
export class NewsletterService {
  constructor(private api: ApiService) {}

  list(page = 1, pageSize = 20, isActive?: boolean): Observable<{ data: NewsletterSubscription[]; meta: any }> {
    const params: any = { page, pageSize };
    if (isActive !== undefined) params.isActive = isActive;
    return this.api.get('/newsletter', params) as Observable<any>;
  }

  subscribe(email: string) {
    return this.api.post('/newsletter/subscribe', { email });
  }

  unsubscribe(email: string) {
    return this.api.post('/newsletter/unsubscribe', { email });
  }
}
